<template>
  <div class="d-print-none"></div>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style lang="scss" scoped></style>
